import { render, staticRenderFns } from "./HomeSectionTitle.vue?vue&type=template&id=38e32e87"
import script from "./HomeSectionTitle.vue?vue&type=script&lang=js"
export * from "./HomeSectionTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports